import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { VuiFlexContainer, VuiLabel, VuiSpinner } from "@vectara/vectara-ui";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { FreeTrialPlanParameters, Plan } from "../../../utils/commonTypes";

type Props = {
  activePlan: Plan | undefined;
  parameters: FreeTrialPlanParameters;
  setParameters: (parameters: FreeTrialPlanParameters) => void;
};

export const FreeTrialParameters = ({ activePlan, parameters, setParameters }: Props) => {
  const [minExpiry, setMinExpiry] = useState<Dayjs>(dayjs());

  useEffect(() => {
    // Set the expiry date to the current date + 30 days if the expiry date is not set.
    const expiry = activePlan?.expiryDate ? dayjs.unix(activePlan.expiryDate) : dayjs().add(30, 'day');
    setParameters({ expiryEpochSecond: expiry.unix() })
    setMinExpiry(expiry)
  }, []);

  const handleExpiryChange = (expiry: Dayjs | null) => {
    if (!expiry) {
      return;
    }
    
    setParameters({ expiryEpochSecond: expiry.unix() });
  };
  
  if(!parameters) {
    return <VuiSpinner />
  }

  return (
    <VuiFlexContainer direction="column">
        <VuiLabel>Expiry</VuiLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={["year", "month", "day"]}
            value={dayjs.unix(parameters.expiryEpochSecond)}
            minDate={minExpiry}
            onChange={handleExpiryChange}
          />
        </LocalizationProvider>
    </VuiFlexContainer>
  );
};
